import { IAppContext } from 'library/App';
import React from 'react';

const AppContenxt = React.createContext<IAppContext>({
  soundOn: false,
});

export default AppContenxt;
